import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AnalyticsService';
import { EventRepository } from '~repositories/EventRepository';
import { Event } from '~entities/Event';
import { events } from '@estee/elc-service-bus';

export class AppointmentLocationSelectedUseCase {
    private readonly eventRepository: EventRepository;
    private readonly storeName: string;

    constructor(storeName: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.storeName = storeName;
    }

    public execute = async () => {
        const appointmentLocationSelectedPayload = {
            event_name: 'appointment booking',
            event_category: 'appointment booking',
            event_action: 'location selected',
            event_label: this.storeName
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_LOCATION_SELECTED,
            type: 'link',
            payload: appointmentLocationSelectedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
